
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/curated-set/[curatedSetId]",
      function () {
        return require("private-next-pages/d/curated-set/[curatedSetId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/curated-set/[curatedSetId]"])
      });
    }
  